import { createStore, applyMiddleware, combineReducers } from 'redux';

export const configStore = (reducers, middlewares, initalState) => createStore(
  combineReducers(reducers),
  initalState,
  applyMiddleware(...middlewares)
);



// WEBPACK FOOTER //
// ./build/config-store.js